export default {
	a_z: "A-Z",
	an_error_has_occurred_when_trying_to_redeem_the_item: "Ocorreu um erro ao tentar resgatar o item",
	confirm_redeem: "Confirmar Resgate",
	confirm_redeeming_the_item: "Confirmar o resgate do item",
	departments: "Departamentos",
	error_redeeming_item: "Erro no resgate do item",
	for: "por",
	insuficient_points_for_redeem: "Pontos insuficientes para resgate",
	item_redeemed: "Item resgatado",
	no_rewards_found: "Não foram encontradas recompensas",
	not_enough_items_in_stock: "Produto indisponível no estoque.",
	not_enough_points_to_redeem_item: "Pontos insuficientes para resgatar o item",
	our_team_will_be_in_touch_for_the_next_steps: "Sujeito à aprovação. Por favor, aguarde a confirmação.",
	popular: "Popular",
	price_bigger_to_smaller: "Preço (maior para menor)",
	price_smaller_to_bigger: "Preço (menor para maior)",
	redeem_now: "Resgatar agora",
	result_plural: "resultados",
	result: "resultado",
	search_for_rewards_here_to_redeem_with_your_points: "Encontre prêmios para resgatar com seus pontos",
	search_partners_or_offerings: "Busque por parceiros ou ofertas",
	you_have_reached_the_max_number_of_redemptions_for_this_category: "Você atingiu o número máximo de resgates para essa categoria.",
	you_redeemed_successfully_the_item: "Resgate identificado: "
}